import React from 'react';

export const IconLightning = ({
  size = 10,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <svg
      className={className}
      width={0.8 * size}
      height={size}
      viewBox="0 0 8 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.34999 0.200012L4.89999 4.10001H7.59999L3.09999 9.80001H2.19999L2.79999 6.50001H0.399994L4.44999 0.200012H5.34999Z"
        fill="currentColor"
      />
    </svg>
  );
};
